import { createContext, useContext } from "react";

interface AppShellContextType {
  setProfileDirty: (dirty: boolean) => void;
  setCalendarTourRunning: (running: boolean) => void;
  setCalendarDirty: (dirty: boolean) => void;
  /** La videollamada (/meet/:token) está abierta: la navegación del encabezado queda bloqueada hasta que termine. Opcional: la app mobile no lo usa. */
  setCallActive?: (active: boolean) => void;
}

const AppShellContext = createContext<AppShellContextType | undefined>(undefined);

export const useAppShell = () => {
  const ctx = useContext(AppShellContext);
  if (!ctx) throw new Error("useAppShell must be used within AppShellProvider");
  return ctx;
};

export { AppShellContext };
